"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReplaySubject_1 = require("rxjs/ReplaySubject");
/**
 * Created by Hayk.Andriasyan on 10/16/2017.
 */
var PinUnpinServiceImpl = /** @class */ (function () {
    function PinUnpinServiceImpl() {
        this.broadcast = new ReplaySubject_1.ReplaySubject();
    }
    PinUnpinServiceImpl.prototype.setPinState = function (state) {
        this.broadcast.next(state);
    };
    PinUnpinServiceImpl.prototype.getPinState = function () {
        return this.broadcast;
    };
    return PinUnpinServiceImpl;
}());
exports.PinUnpinServiceImpl = PinUnpinServiceImpl;
//# sourceMappingURL=pin-unpin.service.impl.js.map